import React from "react";
import UserInfo from "./UserInfo";

// eslint-disable-next-line require-await
const rehydrator = async () => {
  const props = { isRehydrating: true };

  return <UserInfo {...props} />;
};

export default rehydrator;
